let language = {
    "RESOURCE-LIBRARY-PARTNER-INACTIVE-MESSAGE": "当前资源库为空，请点击此处创建您的资源库。",
    "RESOURCE-LIBRARY-PARTNER-INACTIVE-BUTTON-CREATE": "创建",
    "RESOURCE-LIBRARY-PARTNER-INACTIVE-BUTTON-LIBRARY": "图库",

    // 侧边栏
    "RESOURCE-LIBRARY-SIDE-BAR-BUTTON-CREATE": "创建新的目录",
    "RESOURCE-LIBRARY-SIDE-BAR-BUTTON-FILL-SETTING": "填充设置",
    "RESOURCE-LIBRARY-SIDE-BAR-OPTIONS-BUTTON-RENAME": "重命名",
    "RESOURCE-LIBRARY-SIDE-BAR-OPTIONS-BUTTON-DELETE": "删除",
    "RESOURCE-LIBRARY-SIDE-BAR-OPTIONS-BUTTON-FILL-MODE": "填充模式",

    // 内容区
    "RESOURCE-LIBRARY-FUNCTION-BAR-BUTTON-SEARCH": "搜索",
    "RESOURCE-LIBRARY-FUNCTION-BAR-BUTTON-RESET": "重置",
    "RESOURCE-LIBRARY-FUNCTION-BAR-BUTTON-UPLOAD": "上传文件",

    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-SELECT-ALL": "全选",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-SELECTED": "选择",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-MOVE": "移动到",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-COPY": "复制到",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-FILL-SETTING": "填充设置",
    "RESOURCE-LIBRARY-FILE-LIST-BUTTON-DELETE": "删除",
    "RESOURCE-LIBRARY-FILE-LIST-TIPS-FILE-EMPTY": "没有匹配的搜索条件",
    "RESOURCE-LIBRARY-FILE-LIST-TIPS-LIBRARY-EMPTY": "当前资源库没有目录",
    "RESOURCE-LIBRARY-FILE-LIST-TIPS-CATALOG-EMPTY": "当前目录为空",

    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-PREVIEW": "预览",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-MOVE": "移动到",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-COPY": "复制到",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-DELETE": "删除",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-FILL-MODE": "填充模式",
    "RESOURCE-LIBRARY-FILE-LIST-OPTIONS-BUTTON-LOAD-MORE": "加载更多",

    // create-catalog-modal
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-TITLE-NEW": "创建新目录",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-TITLE-RENAME": "重命名目录",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-NEW": "新目录",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-RENAME": "新目录名称",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-PLACEHOLDER": "请输入目录名称",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-ERROR-TIPS": `文件名不能包含以下字符: \ / : * ? " &lt; &gt; |`,
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-EMPTY-TIPS": `名称不能为空`,
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-BUTTON-CANCEL": "取消",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-BUTTON-CREATE": "创建",
    "RESOURCE-LIBRARY-CREATE-CATALOG-MODAL-CONTENT-BUTTON-RENAME": "重命名",

    // fill-mode-modal
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-TITLE": "填充设置",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-DESCRIPTION": "选择默认图像填充",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-BUTTON-CANCEL": "取消",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-BUTTON-SAVE": "保存",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-CROP": "裁剪",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-CONTAIN": "包含",
    "RESOURCE-LIBRARY-FILL-MODE-MODAL-FILL": "填充",
    
    // move-file-tree-modal
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-TITLE-COPY": "复制到目录",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-TITLE-MOVE": "移动到目录",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-INPUT-PLACEHOLDER": "文件夹名称",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-CONFIRM": "确认",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-CANCEL": "取消",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-NEW": "创建新的文件夹",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-MOVE": "移动",
    "RESOURCE-LIBRARY-MOVE-FILE-MODAL-BUTTON-COPY": "复制",
        
    // file-preview-modal
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-TITLE": "预览",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-IMAGE": "Image",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-DOWNLOAD": "下载",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-VIEW": "浏览全图",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-MOVE": "移动到",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-COPY": "复制到",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-DELETE": "删除",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-EDIT": "编辑文件名",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-CANCEL": "取消",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-BUTTON-OK": "确认",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-FILE-BUTTON-MOVE": "移动",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-FILE-BUTTON-COPY": "复制",
    "RESOURCE-LIBRARY-FILE-PREVIEW-MODAL-FILE-NAME-FORMAT": "文件名不能包含以下符号: \\ \/ \: \* \? \" \< \> \|",

    // upload-result-modal
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-TITLE": "上传文件",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-HEADER-IMAGE": "图像",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-HEADER-INFO": "信息",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-HEADER-STATUS": "状态",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-NAME": "名称",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-TYPE": "类型",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-SIZE": "大小",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-CONTENT-MESSAGE": "消息",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-TIPS": "上传文件，关闭后上传的文件会丢失!你确定要关闭上传模式吗?",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-CONFIRM": "确认",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-CANCEL": "取消",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-UPLOAD": "上传",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-BUTTON-OK": "确认",
    
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-SVG-IMAGE": "svg 文件存在于外部链接文件中",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-SVG-FILTER": "过滤器中的feComposite标签包含 'in' 属性",
    "RESOURCE-LIBRARY-UPLOAD-RESULT-MODAL-SVG-RGBA": "不支持 rgba 功能",
};

export { language }